// User Actions
export const LOGOUT = 'LOGOUT';
export const SET_USER_DATA = 'SET_USER_DATA';

// Two-Factor Authentication Actions
export const SET_2FA_REQUIRED = 'SET_2FA_REQUIRED';
export const SET_2FA_SETUP_REQUIRED = 'SET_2FA_SETUP_REQUIRED';
export const SET_2FA_REVERIFICATION_REQUIRED = 'SET_2FA_REVERIFICATION_REQUIRED';
export const CLEAR_2FA_STATE = 'CLEAR_2FA_STATE';
export const SET_TEAM_MEMBERS_DATA = 'SET_TEAM_MEMBERS_DATA';
export const SET_USER_LOADER = 'SET_USER_LOADER';

// Contact Import Actions
export const SET_CONTACT_IMPORT_LOADER = 'SET_CONTACT_IMPORT_LOADER';
export const SET_CONTACT_IMPORTS_DATA = 'SET_CONTACT_IMPORTS_DATA';

// Export Logs Actions
export const SET_EXPORT_LOGS_LOADER = 'SET_EXPORT_LOGS_LOADER';
export const SET_EXPORT_LOGS_DATA = 'SET_EXPORT_LOGS_DATA';

// Snakbar Actions
export const SET_SUCCESS_SNACKBAR = 'SET_SUCCESS_SNACKBAR';
export const SET_ERROR_SNACKBAR = 'SET_ERROR_SNACKBAR';
export const CLEAR_SNACKBAR = 'CLEAR_SNACKBAR';

// Contacts Acctions
export const SET_CONTACTS_DATA = 'SET_CONTACTS_DATA';
export const SET_CONTACTS_LOADER = 'SET_CONTACTS_LOADER';
export const SET_CONTACTS_LABELS = 'SET_CONTACTS_LABELS';
export const SET_CONTACTS_FILTERS = 'SET_CONTACTS_FILTERS';
export const CLEAR_CONTACTS_FILTERS = 'CLEAR_CONTACTS_FILTERS';
export const SET_CONTACTS_DETAIL_DATA = 'SET_CONTACTS_DETAIL_DATA';
export const SET_RETURN_ADDRESSES_DATA = 'SET_RETURN_ADDRESSES_DATA';
export const UPDATE_SINGLE_CONTACT = 'UPDATE_SINGLE_CONTACT';

// Contact Notes Actions
export const SET_CONTACT_NOTES_DATA = 'SET_CONTACT_NOTES_DATA';
export const SET_CONTACT_NOTES_LOADER = 'SET_CONTACT_NOTES_LOADER';
export const CREATE_CONTACT_NOTE = 'CREATE_CONTACT_NOTE';
export const UPDATE_CONTACT_NOTE = 'UPDATE_CONTACT_NOTE';
export const DELETE_CONTACT_NOTE = 'DELETE_CONTACT_NOTE';

// Sender Profiles Actions
export const SET_SENDER_PROFILES_DATA = 'SET_SENDER_PROFILES_DATA';
export const SET_SENDER_PROFILES_LOADER = 'SET_SENDER_PROFILES_LOADER';

// Compaigns Actions
export const SET_CAMPAIGNS_DATA = 'SET_CAMPAIGNS_DATA';
export const SET_CAMPAIGNS_LOADER = 'SET_CAMPAIGNS_LOADER';

// Templates Action
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';
export const GET_ONE_TEMPLATE = 'GET_ONE_TEMPLATE';
export const TEMPLATE_LOADING = 'TEMPLATE_LOADING';
export const TEMPLATE_PAGINATION_CHANGE = 'TEMPLATE_PAGINATION_CHANGE';
export const TEMPLATE_SEARCH = 'TEMPLATE_SEARCH';
export const CLEAR_ALL_TEMPLATE = 'CLEAR_ALL_TEMPLATE';
export const CLEAR_TEMPLATE_FIELDS = 'CLEAR_TEMPLATE_FIELDS';
export const GET_DYNAMIC_FIELDS_FROM_SERVER = 'GET_DYNAMIC_FIELDS_FROM_SERVER';
export const LOAD_DATA_FROM_LOCAL_STORAGE = 'LOAD_DATA_FROM_LOCAL_STORAGE';
export const CLEAR_TEMPLATE = 'CLEAR_TEMPLATE';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const CLEAR_FIELDS = 'CLEAR_FIELDS';

//Product
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SELECT_POSTCARD = 'SELECT_POSTCARD';

// Orders Actions
export const SET_ORDERS_DATA = 'SET_ORDERS_DATA';
export const SET_ORDERS_LOADER = 'SET_ORDERS_LOADER';
export const SET_ORDERS_FILTERS_LABELS = 'SET_ORDERS_FILTERS_LABELS';
export const SET_ORDERS_FILTERS = 'SET_ORDERS_FILTERS';
export const CLEAR_ORDERS_FILTERS = 'CLEAR_ORDERS_FILTERS';
export const SET_ORDERS_DETAIL_CONTACTS_DATA = 'SET_ORDERS_DETAIL_CONTACTS_DATA';
export const SET_ORDERS_DETAIL_OVERVIEW_DETAIL = 'SET_ORDERS_DETAIL_OVERVIEW_DETAIL';
export const SET_ORDER_DETAIL_LOADER = 'SET_ORDER_DETAIL_LOADER';
export const SET_ORDER_DETAIL_CONTACTS_LOADER = 'SET_ORDER_DETAIL_CONTACTS_LOADER';
export const CONTACTS_SEARCH = 'CONTACTS_SEARCH';
export const SET_ORDERS_CAMPAIGNS_DETAIL_DETAIL = 'SET_ORDERS_CAMPAIGNS_DETAIL_DETAIL';
export const SET_ORDER_BATCHING_DETAIL = 'SET_ORDER_BATCHING_DETAIL';

// Product Actions
export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES';
export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS';
export const SET_PRODUCTS_DATA = 'SET_PRODUCTS_DATA';

// Api-Keys Actions
export const SET_API_KEYS_DATA = 'SET_API_KEYS_DATA';
export const SET_API_KEYS_LOADER = 'SET_API_KEYS_LOADER';

// CustomField Actions
export const SET_CUSTOM_FIELDS_DATA = 'SET_CUSTOM_FIELDS_DATA';
export const SET_CUSTOM_FIELDS_LOADER = 'SET_CUSTOM_FIELDS_LOADER';
export const SET_CUSTOM_FIELDS_CATALOG_DATA = 'SET_CUSTOM_FIELDS_CATALOG_DATA';

// General Setting
export const SET_GENERAL_DATA = 'SET_GENERAL_DATA';

//Stripe Actions
export const SET_STRIPE_PAYMENT_METHODS = 'SET_STRIPE_PAYMENT_METHODS';
export const SET_STRIPE_INVOICES = 'SET_STRIPE_INVOICES';
export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const SET_TRANSACTIONS_LOADER = 'SET_TRANSACTIONS_LOADER';
export const SET_METHOD_LOADER = 'SET_METHOD_LOADER';
export const CLEAR_STRIPE_PAYMENT_METHODS = 'CLEAR_STRIPE_PAYMENT_METHODS';

// Payment Failure Modal Actions
export const SET_PAYMENT_FAILED_MODAL = 'SET_PAYMENT_FAILED_MODAL';
export const CLEAR_PAYMENT_FAILED_MODAL = 'CLEAR_PAYMENT_FAILED_MODAL';
// Closes the modal without resetting the _paymentFailedDispatched flag — the server
// block remains active; the interceptor will not reopen the modal on future responses
// that still carry X-Payment-Failed-At. Recovery is still detected silently via
// clearPaymentFailedModalIfNeeded when a response arrives without the header.
export const DISMISS_PAYMENT_FAILED_MODAL = 'DISMISS_PAYMENT_FAILED_MODAL';

// Tags Actions
export const SET_TAGS_DATA = 'SET_TAGS_DATA';
export const SET_TAGS_LOADER = 'SET_TAGS_LOADER';

// Webhooks Actions
export const SET_WEBHOOKS_DATA = 'SET_WEBHOOKS_DATA';
export const SET_WEBHOOKS_EVENTS_DATA = 'SET_WEBHOOKS_EVENTS_DATA';
export const SET_WEBHOOKS_LOADER = 'SET_WEBHOOKS_LOADER';

// Dashboard
export const SET_DASHBOARD_WIDGETS_SPENDINGS = 'SET_DASHBOARD_WIDGETS_SPENDINGS';
export const SET_DASHBOARD_WIDGETS_DATA = 'SET_DASHBOARD_WIDGETS_DATA';
export const SET_DASHBOARD_CHART_DATA = 'SET_DASHBOARD_CHART_DATA';
export const SET_LIMIT_MODAL = 'SET_LIMIT_MODAL';
export const SET_DYNAMIC_LIMIT_MODAL = 'SET_DYNAMIC_LIMIT_MODAL';

// GENERAL SETTINGS
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS';
// BRANDING ASSETS
export const CREATE_BRANDING_ASSET = 'CREATE_BRANDING_ASSET';
export const UPDATE_BRANDING_ASSET = 'UPDATE_BRANDING_ASSET';
export const DELETE_BRANDING_ASSET = 'DELETE_BRANDING_ASSET';
export const SET_BRANDING_ASSETS_DATA = 'SET_BRANDING_ASSETS_DATA';
export const SET_BRANDING_ASSETS_LOADER = 'SET_BRANDING_ASSETS_LOADER';

// ADMIN DASHBOARD ACTIONS //

// Admin Users Actions
export const SET_ADMIN_USERS_DATA = 'SET_ADMIN_USERS_DATA';
export const SET_ADMIN_USERS_LOADER = 'SET_ADMIN_USERS_LOADER';
export const SET_ADMIN_USERS_FILTERS_LABELS = 'SET_ADMIN_USERS_FILTERS_LABELS';
export const SET_ADMIN_USERS_FILTERS = 'SET_ADMIN_USERS_FILTERS';
export const CLEAR_ADMIN_USERS_FILTERS = 'CLEAR_ADMIN_USERS_FILTERS';
export const SET_ADMIN_USERS_USER_WALLET_HISTORY = 'SET_ADMIN_USERS_USER_WALLET_HISTORY';
export const SET_ADMIN_USERS_USER_WALLET_HISTORY_LOADER =
  'SET_ADMIN_USERS_USER_WALLET_HISTORY_LOADER';

// Admin Batches Actions
export const SET_ADMIN_BATCHES_DATA = 'SET_ADMIN_BATCHES_DATA';
export const SET_ADMIN_BATCHES_LOADER = 'SET_ADMIN_BATCHES_LOADER';
export const SET_ADMIN_BATCHES_FILTERS_LABELS = 'SET_ADMIN_BATCHES_FILTERS_LABELS';
export const SET_ADMIN_BATCHES_FILTERS = 'SET_ADMIN_BATCHES_FILTERS';
export const CLEAR_ADMIN_BATCHES_FILTERS = 'CLEAR_ADMIN_BATCHES_FILTERS';

// Admin Orders Actions
export const SET_ADMIN_ORDERS_DATA = 'SET_ADMIN_ORDERS_DATA';
export const SET_ADMIN_ORDERS_LOADER = 'SET_ADMIN_ORDERS_LOADER';
export const SET_ADMIN_ORDER_DISPATCH_LOADER = 'SET_ADMIN_ORDER_DISPATCH_LOADER';
export const SET_ADMIN_ORDERS_FILTERS_LABELS = 'SET_ADMIN_ORDERS_FILTERS_LABELS';
export const SET_ADMIN_ORDERS_FILTERS = 'SET_ADMIN_ORDERS_FILTERS';
export const CLEAR_ADMIN_ORDERS_FILTERS = 'CLEAR_ADMIN_ORDERS_FILTERS';

// Admin Dashboaard Actions
export const SET_ADMIN_DASHBOARD_CHART_DATA = 'SET_ADMIN_DASHBOARD_CHART_DATA';

// Admin Template Actions
export const SET_ALL_ADMIN_TEMPLATE_CATEGORIES_DATA = 'SET_ALL_ADMIN_TEMPLATE_CATEGORIES_DATA';
export const SET_ADMIN_TEMPLATE_CATEGORIES_DATA = 'SET_ADMIN_TEMPLATE_CATEGORIES_DATA';
export const SET_ADMIN_TEMPLATE_CATEGORIES_LOADER = 'SET_ADMIN_TEMPLATE_CATEGORIES_LOADER';

// Admin Lookups Actions
export const SET_ADMIN_LOOKUPS_DATA = 'SET_ADMIN_LOOKUPS_DATA';
export const SET_ADMIN_LOOKUPS_LOADER = 'SET_ADMIN_LOOKUPS_LOADER';
export const SET_ADMIN_LOOKUPS_FILTERS = 'SET_ADMIN_LOOKUPS_FILTERS';
export const CLEAR_ADMIN_LOOKUPS_FILTERS = 'CLEAR_ADMIN_LOOKUPS_FILTERS';

// Admin Queries Actions
export const SET_ADMIN_QUERIES_DATA = 'SET_ADMIN_QUERIES_DATA';
export const SET_ADMIN_QUERY_DETAILS_DATA = 'SET_ADMIN_QUERY_DETAILS_DATA';
export const SET_ADMIN_QUERIES_LOADER = 'SET_ADMIN_QUERIES_LOADER';
export const SET_ADMIN_QUERY_DETAILS_LOADER = 'SET_ADMIN_QUERY_DETAILS_LOADER';

// Designer Queries Actions
export const SET_DESIGNER_CREDIT_PACKAGES = 'SET_DESIGNER_CREDIT_PACKAGES';
export const SET_DESIGNER_CREDIT_PACKAGES_LOADER = 'SET_DESIGNER_CREDIT_PACKAGES_LOADER';
export const SET_DESIGNER_HISTORY_DATA = 'SET_DESIGNER_HISTORY_DATA';
export const SET_DESIGNER_HISTORY_LOADER = 'SET_DESIGNER_HISTORY_LOADER';
export const CLEAR_DESIGNER_HISTORY_DATA = 'CLEAR_DESIGNER_HISTORY_DATA';

// Admin Pricing Actions
export const SET_ADMIN_PRICING_POSTAGE_DATA = 'SET_ADMIN_PRICING_POSTAGE_DATA';
export const SET_ADMIN_PRICING_POSTAGE_LOADER = 'SET_ADMIN_PRICING_POSTAGE_LOADER';
export const SET_ADMIN_PRICING_POSTAGE_HISTORICAL_DATA =
  'SET_ADMIN_PRICING_POSTAGE_HISTORICAL_DATA';
export const SET_ADMIN_PRICING_PLANS_DATA = 'SET_ADMIN_PRICING_PLANS_DATA';
export const SET_ADMIN_PRICING_PLANS_LOADER = 'SET_ADMIN_PRICING_PLANS_LOADER';
export const SET_ADMIN_PRICING_COST_OF_GOODS_DATA = 'SET_ADMIN_PRICING_COST_OF_GOODS_DATA';
export const SET_ADMIN_PRICING_COST_OF_GOODS_HISTORICAL_DATA =
  'SET_ADMIN_PRICING_COST_OF_GOODS_HISTORICAL_DATA';
export const SET_ADMIN_PRICING_COST_OF_GOODS_LOADER = 'SET_ADMIN_PRICING_COST_OF_GOODS_LOADER';
export const SET_ADMIN_PRICING_TIERS_DATA = 'SET_ADMIN_PRICING_TIERS_DATA';
export const SET_ADMIN_PRICING_TIERS_LOADER = 'SET_ADMIN_PRICING_TIERS_LOADER';

// Sources Actions
export const SET_SOURCES = 'SET_SOURCES';
export const SET_SOURCES_LOADER = 'SET_SOURCES_LOADER';

// Phone Tracking Actions
export const SET_PHONE_TRACKING_DATA = 'SET_PHONE_TRACKING_DATA';
export const SET_PHONE_TRACKING_LOADER = 'SET_PHONE_TRACKING_LOADER';
export const SET_PHONE_TRACKING_DETAIL_DATA = 'SET_PHONE_TRACKING_DETAIL_DATA';
export const SET_PHONE_TRACKING_DETAIL_LOADER = 'SET_PHONE_TRACKING_DETAIL_LOADER';
export const SET_PHONE_TRACKING_HISTORY_DATA = 'SET_PHONE_TRACKING_HISTORY_DATA';
export const SET_PHONE_TRACKING_HISTORY_LOADER = 'SET_PHONE_TRACKING_HISTORY_LOADER';
export const SET_PHONE_TRACKING_SMS_HISTORY_DATA = 'SET_PHONE_TRACKING_SMS_HISTORY_DATA';
export const SET_PHONE_TRACKING_SMS_HISTORY_LOADER = 'SET_PHONE_TRACKING_SMS_HISTORY_LOADER';
export const SET_PHONE_TRACKING_LOOKUP_DATA = 'SET_PHONE_TRACKING_LOOKUP_DATA';
export const SET_PHONE_TRACKING_LOOKUP_LOADER = 'SET_PHONE_TRACKING_LOOKUP_LOADER';
export const CREATE_PHONE_TRACKING_NUMBER = 'CREATE_PHONE_TRACKING_NUMBER';
export const UPDATE_PHONE_TRACKING_NUMBER = 'UPDATE_PHONE_TRACKING_NUMBER';
export const RELEASE_PHONE_TRACKING_NUMBER = 'RELEASE_PHONE_TRACKING_NUMBER';

// QR Code Actions
export const SET_QR_CODES_DATA = 'SET_QR_CODES_DATA';
export const SET_QR_CODES_LOADER = 'SET_QR_CODES_LOADER';
export const CREATE_QR_CODE = 'CREATE_QR_CODE';
export const UPDATE_QR_CODE = 'UPDATE_QR_CODE';
export const DELETE_QR_CODE = 'DELETE_QR_CODE';
export const UPDATE_QR_CODE_STATUS = 'UPDATE_QR_CODE_STATUS';
export const SET_QR_CODE_SCANNED_CONTACTS_DATA = 'SET_QR_CODE_SCANNED_CONTACTS_DATA';
export const SET_QR_CODE_SCANNED_CONTACTS_LOADER = 'SET_QR_CODE_SCANNED_CONTACTS_LOADER';
